import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import mutations from './mutations';
import cacheInLocalStorage from './localCache/cacheInLocalStorage';
import cacheInSession from './localCache/cacheInSession';
import moduleA from './modules/a';
import moduleB from './modules/b';

Vue.use(Vuex);

const initState = {
  token: cacheInLocalStorage.get('token') || '',
  localuser: cacheInLocalStorage.get('localuser') || {},
  currentParkId: cacheInLocalStorage.get('currentParkId') || 1000,
  // 购物车列表
  cartList: cacheInLocalStorage.get('cartList') || [],
  address: cacheInLocalStorage.get('address') || '',
  curPath: cacheInSession.get('curPath') || '',
  parkServiceList: cacheInSession.get('parkServiceList') || [],
  qrcodeServiceInfo: cacheInSession.get('qrcodeServiceInfo') || {},
};


export default new Vuex.Store({
  getters,
  mutations,
  state: initState,
  modules: {
    a: moduleA,
    b: moduleB,
  }
});




// WEBPACK FOOTER //
// ./src/store/index.js